import { getCountry } from '../ForeignUtils';
import { getScreenName, getSkuType, getUserIsLoggedIn } from '../helper';
import { getPaymentOption } from './instrumentationUtils';
import { fireEvent } from '../fireEvent';

export const viewedPaymentPageEvent = (
  paymentMethods,
  selectedAddress,
  orderData,
) => {
  const method_showing = getPaymentOption(paymentMethods);
  const user_mobile = selectedAddress?.mobile;
  const sku_nickname = orderData?.productNickNameAndUrl?.nickName;
  const sku_type = getSkuType(orderData?.details?.products?.[0]?.sku_type);
  let commaSeperatedIds;
  let commaSeperatedNames;
  orderData?.details?.products?.forEach((element) => {
    if (commaSeperatedIds || commaSeperatedNames) {
      commaSeperatedIds += ',' + JSON.stringify(element?.product_id);
      commaSeperatedNames += ',' + element?.product_nickname;
    } else {
      commaSeperatedIds = JSON.stringify(element?.product_id);
      commaSeperatedNames = element?.product_nickname;
    }
  });
  const pricing_param = orderData?.pricing_param;
  const conversion_param = orderData?.conversion_param;
  fireEvent({
    category: 'viewed_payment_page',
    screen_name: getScreenName(),
    support_variable: method_showing,
    user_mobile,
    sku_nickname,
    sku_type,
    id: commaSeperatedIds,
    name: commaSeperatedNames,
    pricing_param,
    conversion_param,

    country: getCountry(),
  });
};

export const viewed_cod_popup = () => {
  fireEvent({
    category: 'viewed_popup',
    screen_name: 'payment_page',
    parent: 'save_extra_by_paying_online',
  });
};

export const onClickPaymentMethodEvent = (mode) => {
  fireEvent({
    category: 'clicked_payment_method',
    screen_name: 'payment_page',
    support_variable: mode,
    country: getCountry(),
  });
};

export const fireApiHandler = (req, error, payload) => {
  fireEvent({
    category: 'api_error',
    payload: payload ? JSON.stringify(payload).slice(0, 99) : null,
    req: req?.slice(0, 99),
    error: error?.toString().slice(0, 99),
    path_name: window.location.pathname?.toString().slice(0, 99),
  });
};

export const codPopupOptionClickEvent = (ctaText) => {
  fireEvent({
    category: 'clicked_cta',
    screen_name: 'payment_page',
    parent: 'save_extra_by_paying_online',
    cta: ctaText,
  });
};

export const eventOnClickTrustSection = (heading) => {
  fireEvent({
    category: 'clicked_card_on_payment_page',
    screen_name: 'payment_page',
    card_name: heading,
  });
};

export const openOrderConfirmPopupEvent = () => {
  fireEvent({
    category: 'viewed_popup',
    screen_name: 'payment_page',
    support_variable: getUserIsLoggedIn() ? 'logged_in' : 'new_user',
    parent: 'order_confirmation',
  });
};

export const clickPlaceOrderEvent = () => {
  fireEvent({
    category: 'clicked_cta',
    screen_name: 'payment_page',
    support_variable: getUserIsLoggedIn() ? 'logged_in' : 'new_user',
    parent: 'order_confirmation',
    cta: 'PLACE ORDER',
  });
};

export const discardPopupEvent = (type) => {
  fireEvent({
    category: 'discard_popup',
    screen_name: 'payment_page',
    support_variable: getUserIsLoggedIn() ? 'logged_in' : 'new_user',
    parent: type,
  });
};
